;(function() {
"use strict";

angular.module('kauffman-press-frontend.directives', [
  'kauffman-press-frontend.DashboardRequest',
])
  .component('placeSelector', {
    templateUrl: 'partials/place-selector.html',
  })
  .component('selectionHeader', {
    templateUrl: 'partials/selection-header.html',
    controller: HeaderCtrl,
  })
  .component('selectionMap', {
    template: '<div id="map"></div>',
    controller: SelectionMapCtrl,
  })
  .component('selectionSidebar', {
    templateUrl: 'partials/selection-sidebar.html',
    controller: SidebarCtrl,
  })
  .component('contactForm', {
    templateUrl: 'partials/contact-form.html',
    controller: ContactFormCtrl,
  });

HeaderCtrl.$inject = ['$rootScope', '$window', 'EVENTS', 'globalState'];
function HeaderCtrl($rootScope, $window, EVENTS, globalState) {
  this.globalState = globalState;

  this.onClickOpenContactForm = function() {
    this.globalState.isShowingContactDialog = true;
  };

  globalState.mapReady().then((map) => {
    const geocoder = new $window.MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      countries: 'US',
      flyTo: {
        curve: 1,
        speed: 2
      },
      placeholder: 'Search for a Place',
      zoom: 12
    });

    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

    geocoder.on('result', (result) => {
      map.once('idle', () => {
        $rootScope.$broadcast(EVENTS.location_selected, result.result);
      });
    });
  });
}

SelectionMapCtrl.$inject = [
  '$location',
  '$scope',
  '$window',
  'EVENTS',
  'globalState',
  'MYSW_DOMAIN',
  'SELECTION_LIMIT'
];
function SelectionMapCtrl(
  $location,
  $scope,
  $window,
  EVENTS,
  globalState,
  MYSW_DOMAIN,
  SELECTION_LIMIT
) {
  $window.mapboxgl.accessToken = 'pk.eyJ1IjoibXlzaWRld2FsayIsImEiOiJjajJhbGszMXcwMDZrMnFzNm1vNzYydnB5In0.mwAOLpOdMBbeJonMNW2oVQ';
  const _ = $window._;

  const primaryColor = '#378ce3';
  const secondaryColor = '#e85e13';
  const lineWidth = [
    'interpolate',
    ['exponential', 1.5],
    ['zoom'],
    10,
    1.5,
    18,
    10
  ];
  const selectedLineWidth = [
    'interpolate',
    ['exponential', 1.5],
    ['zoom'],
    10,
    3,
    18,
    30
  ];
  const selectedLineOffset = [
    'interpolate',
    ['exponential', 1.5],
    ['zoom'],
    10,
    1.5,
    18,
    15
  ];

  const map = new $window.mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/light-v10',
    center: [-94.6104, 39.0962],
    zoom: 4,
    attributionControl: false,
  });

  globalState.map = map;
  const proto = $location.protocol();

  map.on('load', function () {
    map.addSource('features', {
      'type': 'vector',
      'tiles': [`${proto}://a-tile.${MYSW_DOMAIN}/public/feature-class/4/{z}/{x}/{y}.mvt`],
      'minzoom': 8,
      'maxzoom': 18
    });

    map.addControl(new mapboxgl.AttributionControl({ customAttribution: '<a href="https://mysidewalk.com" target="_blank" rel="noopener">&copy; mySidewalk</a>' }), 'bottom-right');
    map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'bottom-right');

    map.addLayer({
      'id': 'features-click',
      'type': 'fill',
      'source': 'features',
      'source-layer': 'public/feature-class/4',
      'paint': {
        'fill-color': 'rgba(0,0,0,0.0)'
      }
    }, 'waterway-label');

    map.addLayer({
      'id': 'features',
      'type': 'line',
      'source': 'features',
      'source-layer': 'public/feature-class/4',
      'paint': {
        'line-color': '#959595',
        'line-width': lineWidth
      }
    }, 'waterway-label');

    map.addLayer({
      'id': 'features-primary-fill',
      'type': 'fill',
      'source': 'features',
      'source-layer': 'public/feature-class/4',
      'paint': {
        'fill-color': primaryColor,
        'fill-opacity': 0.8
      },
      'filter': ['in', '$id', '']
    }, 'waterway-label');

    map.addLayer({
      'id': 'features-primary-line',
      'type': 'line',
      'source': 'features',
      'source-layer': 'public/feature-class/4',
      'paint': {
        'line-opacity': 1,
        'line-color': primaryColor,
        'line-width': selectedLineWidth,
        'line-offset': selectedLineOffset
      },
      'filter': ['==', '$id', '']
    }, 'waterway-label');

    map.addLayer({
      'id': 'features-comparison-fill',
      'type': 'fill',
      'source': 'features',
      'source-layer': 'public/feature-class/4',
      'paint': {
        'fill-color': secondaryColor,
        'fill-opacity': 0.8
      },
      'filter': ['in', '$id', '']
    }, 'waterway-label');

    map.addLayer({
      'id': 'features-comparison-line',
      'type': 'line',
      'source': 'features',
      'source-layer': 'public/feature-class/4',
      'paint': {
        'line-opacity': 1,
        'line-color': secondaryColor,
        'line-width': selectedLineWidth,
        'line-offset': selectedLineOffset
      },
      'filter': ['==', '$id', '']
    }, 'waterway-label');

    const updateSelectedFeatures = function() {
      const { selectedFeatures } = globalState;
      const selectedFeatureIds = selectedFeatures.keys();
      const primaryId = selectedFeatureIds.shift();
      const primaryFilter = ['==', '$id', primaryId || ''];
      const comparisonFilter = ['in', '$id', ...selectedFeatureIds];
      map.setFilter('features-primary-fill', primaryFilter);
      map.setFilter('features-primary-line', primaryFilter);
      map.setFilter('features-comparison-fill', comparisonFilter);
      map.setFilter('features-comparison-line', comparisonFilter);
    };

    const selectFeatureAroundPoint = function(point) {
      const { selectedFeatures } = globalState;
      const features = _.uniq(map.queryRenderedFeatures(point, {layers: ['features-click']}), feature => feature.id);
      const isMutuallyExclusive = SELECTION_LIMIT === 1;
      features.forEach((feature) => {
        if (isMutuallyExclusive && !selectedFeatures.isFirst(feature)) {
          selectedFeatures.clear();
          selectedFeatures.add(feature);
        }
        else if (selectedFeatures.isFirst(feature)) {
          selectedFeatures.clear();
        }
        else if (!isMutuallyExclusive) {
          !selectedFeatures.has(feature) && selectedFeatures.size < SELECTION_LIMIT
            ? selectedFeatures.add(feature)
            : selectedFeatures.delete(feature);
        }
      });
      updateSelectedFeatures();
      $scope.$apply();
    };

    map.on('click', (event) => {
      selectFeatureAroundPoint(event.point);
    });

    const DESIGNATED_FEATURES_ID = 'features-designated';

    const removeDesignationLayer = function() {
      if (map.getLayer(DESIGNATED_FEATURES_ID)) map.removeLayer(DESIGNATED_FEATURES_ID);
    };

    const addDesignationLayer = function(key) {
      map.addLayer({
        'id': DESIGNATED_FEATURES_ID,
        'type': 'fill',
        'source': 'features',
        'source-layer': 'public/feature-class/4',
        'paint': {
          'fill-color': primaryColor,
          'fill-opacity': 0.25
        },
        'filter': ['==', key, 1]
      }, 'waterway-label');
    };

    const updateFeatureDesignation = function(newDesignation, oldDesignation) {
      if (oldDesignation) {
        removeDesignationLayer();
      }
      if (newDesignation) {
        addDesignationLayer(newDesignation);
      }
    };

    $scope.$watch(() => globalState.selectedFeatureDesignation, updateFeatureDesignation);
    $scope.$watch(() => globalState.selectedFeatures.size, updateSelectedFeatures);

    const onLocationSelected = function(event, geocoderResult) {
      const point = map.project(geocoderResult.center);
      const areFeaturesLoaded = map.isSourceLoaded('features');
      const onFeatureDataChange = function(e) {
        if (e.sourceId === 'features' && e.isSourceLoaded) {
          selectFeatureAroundPoint(point);
          map.off('data', onFeatureDataChange);
        }
      };
      if (!areFeaturesLoaded) {
        map.on('data', onFeatureDataChange);
      }
      else {
        selectFeatureAroundPoint(point);
      }
    };

    $scope.$on(EVENTS.location_selected, onLocationSelected);
  });
}

SidebarCtrl.$inject = ['globalState', 'SELECTION_LIMIT'];
function SidebarCtrl(globalState, SELECTION_LIMIT) {
  this.status = {
    isShowingLegend: true,
    isShowingInfo: false,
  };
  this.SELECTION_LIMIT = SELECTION_LIMIT;

  this.toggleLegend = function() {
    this.status.isShowingLegend = !this.status.isShowingLegend;
  };

  this.toggleInfo = function() {
    this.status.isShowingInfo = !this.status.isShowingInfo;
  };

  Object.defineProperty(this, 'selectedFeatures', {
    get: () => globalState.selectedFeatures.values(),
  });

  this.featureDesignations = [
    { label: 'None', key: null },
  ];

  this.selectedFeatureDesignation = globalState.selectedFeatureDesignation;

  this.onChangeFeatureDesignation = function(designation) {
    globalState.selectedFeatureDesignation = designation;
  };

  this.removeAllFeatures = function() {
    globalState.selectedFeatures.clear();
  };

  this.removeFeature = function(feature) {
    globalState.selectedFeatures.delete(feature);
  };
}

ContactFormCtrl.$inject = ['DashboardRequest', 'globalState', 'PRESS_SITE_ID'];
function ContactFormCtrl(DashboardRequest, globalState, PRESS_SITE_ID) {
  this.globalState = globalState;

  this.requestFields = {
    features: [],
    site: PRESS_SITE_ID,
  };

  this.contactFields = {
    firstName: '',
    lastName: '',
    email: '',
  };

  this.status = {
    isShowingSuccessMessage: false,
    error: null,
    isSubmitting: false,
  };

  this.onSubmit = () => {
    this.requestFields.features = globalState.selectedFeatures.values().map(feature => feature.properties.shid);
    const props = Object.assign(
      {},
      this.requestFields,
      { requestInput: this.contactFields }
    );

    this.status.isSubmitting = true;
    DashboardRequest.create(props)
      .then(() => {
        this.status.isShowingSuccessMessage = true;
        this.clearError();
      })
      .finally(() => {
        this.status.isSubmitting = false;
      });
  };

  this.closeDialog = function() {
    globalState.isShowingContactDialog = false;
    this.status.isShowingSuccessMessage = false;
    this.clearError();
  };

  this.clearError = function() {
    this.status.error = null;
  };

  this.getFirstSelectedFeature = function() {
    const firstFeature = this.globalState.selectedFeatures.values()[0];
    return firstFeature && firstFeature.properties.label_long;
  };
}
}());
